import React from "react";
import { Mail, MapPin } from "lucide-react";

const Contact = () => {
  return (
    <section id="contact" className="contact">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">Contact Us</h2>
        </div>

        <div className="contact-content">
          <div className="contact-info">
            <div className="contact-item">
              <div className="contact-icon">
                <Mail />
              </div>
              <div className="contact-details">
                <h3 className="contact-label">Email</h3>
                <a
                  href="mailto:info@doubletapinnovations.ai"
                  className="contact-value"
                >
                  info@doubletapinnovations.ai
                </a>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-icon">
                <MapPin />
              </div>
              <div className="contact-details">
                <h3 className="contact-label">Location</h3>
                <p className="contact-value">Chennai, India</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
